import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHot({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.908 3.703l.014.144.012.162c.175 1.588.747 2.363 2.13 3.35l.43.296.249.17C19.105 9.458 20 10.868 20 14.143 20 18.487 16.414 22 12 22s-8-3.513-8-7.857c0-1.39.154-2.438.74-3.806l.143-.322c.019-.04.091-.175.217-.404a1 1 0 011.686-.103l.063.098.158.272.108.165a.116.116 0 00.211-.063C7.44 7.137 8.7 4.992 10.924 3.182l.261-.208c.071-.055.2-.147.386-.276a1.5 1.5 0 012.309.866l.027.14zm-2.704 1.973l-.085.072-.092.093c-.059.06-.11.118-.156.173-1.3 1.563-1.798 3.415-1.437 5.917l.052.33.03.132a1.05 1.05 0 01-1.526 1.094 6.35 6.35 0 01-1.512-1.143l-.244-.254-.07.281C6.038 12.93 6 13.478 6 14.143 6 17.373 8.682 20 12 20s6-2.627 6-5.857c0-2.064-.53-3.353-2.385-4.665l-.487-.333c-1.31-.909-2.165-1.746-2.668-2.88l-.102-.248-.044-.094a.759.759 0 00-1.11-.248zm2.5 7.008a.969.969 0 011.207-.447l.103.047.1.057c.49.302.886.865.886 1.909 0 2.071-1.741 3.75-3.889 3.75C10.867 18 9 17.246 9 15.75c0-1.5 1.556-1.5 2.333-1.5 1.523 0 2.056-.56 2.24-1.167l.038-.145a.966.966 0 01.092-.254z"
        fill={color}
      />
    </svg>
  )
}

export default SvgHot
